import { loginCompany, loginOrg } from '@/utils/LoginContext';
import request from '@/utils/request';


export async function saveProcessWave(payload) {
  return request(`/iwms-wms/wms/processWave`, {
    method: 'POST',
    body: payload,
  })
}

export async function saveProcessWaveRaw(payload) {
  return request(`/iwms-wms/wms/processWave/save/raw?billUuid=${payload.billUuid}`, {
    method: 'POST',
    body: payload.raws,
  })
}

export async function queryProcessWaveRaw(payload) {
  return request(`/iwms-wms/wms/processWave/rawArticle?billNumber=${payload}&dcUuid=${loginOrg().uuid}`);
}

export async function getProcessWave(payload) {
  return request(`/iwms-wms/wms/processWave?uuid=${payload}`)
}

export async function page(payload) {
  return request(`/iwms-wms/wms/processWave/page`, {
    method: 'POST',
    body: payload,
  })
}

export async function allocateInfo(payload) {
  return request(`/iwms-wms/wms/processWave/allocate/store`, {
    method: 'POST',
    body: payload,
  })
}

export async function submit(payload) {
  return request(`/iwms-wms/wms/processWave/submit`, {
    method: 'POST',
    body: payload,
  })
}

export async function verifyContainer(payload) {
  return request(`/iwms-wms/wms/processWave/${payload.containerBarcode}/verify?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&storeUuid=${payload.storeUuid}&allocateBinCode=${payload.allocateBinCode}`, {
    method: 'POST',
  })
}

export async function skip(payload) {
  return request(`/iwms-wms/wms/processWave/skip?articleUuid=${payload.articleUuid}&dcUid=${loginOrg().uuid}&processWaveBillNumber=${payload.processWaveBillNumber}&storeUuid=${payload.storeUuid}&waveBillNumber=${payload.waveBillNumber}`, {
    method: 'POST',
  })
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/processWave/finish`, {
    method: 'POST',
    body: payload
  })
}

export async function verifyUnAllocateStore(payload) {
  return request(`/iwms-wms/wms/processWave/verify/store?dcUuid=${loginOrg().uuid}&billNumber=${payload.billNumber}`, {
    method: 'POST',
  })
}

export async function switchStore(payload) {
  return request(`/iwms-wms/wms/processWave/switch?articleUuid=${payload.articleUuid}&dcUuid=${loginOrg().uuid}&processWaveBillNumber=${payload.processWaveBillNumber}&storeUuid=${payload.storeUuid}&waveBillNumber=${payload.waveBillNumber}&switchStoreUuid=${payload.switchStoreUuid}`, {
    method: 'POST',
  })
}

export async function adjAllocateQty(payload) {
  return request(`/iwms-wms/wms/processWave/adjAllocateQty`, {
    method: 'POST',
    body: payload
  })
}
